// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1F-On","addWidgetButton":"Header_addWidgetButton__2FUWJ","dashboardTabs":"Header_dashboardTabs__aYdbb","active":"Header_active__1Y0xJ"};